<template>
	<div class="pt-60 box-s">
	  <div class="bg_f ps_top"><Nav :navList="navList" @getItem="getItem"></Nav></div>
    
		<div class="plr-16">
			<van-list
				v-model="loading"
				:finished="finished"
				:finished-text="finishedtext"
				@load="initData"
			>
				<div class="list_every flexs ex_every pd-15 mb-16 box-s" v-for="(item, index) in list" :key="index" @click="getDetail(item.id)">
					<!-- <img class="ex_img wh_90 b-radius-6" v-lazy="item.img" alt=""> -->
          <van-image class="ex_img wh_90 b-radius-6" :src="item.img" :lazy-load="true">
						<template v-slot:error>
							<img class="wh_36 b-radius-6" src="../../assets/img/icon/error.png" alt="">
						</template>
					</van-image>
					<div class="flex1 c1 fz-15 ml-15">
						<div class="fw-500 l-h-15 w208 text-hide">{{item.title}}</div>
						<div class="l-h-15 c0 fw-500 mb-14 mt-14">{{item.integral}}积分</div>
						<div class="fz-14 l-h-14">{{item.time}} 兑换</div>
					</div>
				</div>
			</van-list>
			
		</div>
		<noData v-if="show"></noData>
		<load :loadFlag="loadFlag"></load>
	</div>
</template>
<script>
  import Nav from '@/components/nav'
	import load from "@/components/loading"
  import { goodsExchangeRecord } from '@/api/api.js'
	import noData from "@/components/noData"
	import { getList } from '@/utils/common'
	export default {
		components: {
			Nav,
			noData,
			load
		},
		data() {
			return {
			  navList: [{title: '未领取',id: 1 }, { title: '已领取', id: 2 }],
				list: [],
				status: 1,
				loading: false,
				finished: false,
				finishedtext: '',
				show:false,
				page: 1,
				loadFlag: false
			};
		},
		created() {
		},
		methods: {
			initData(){
				getList(this, goodsExchangeRecord, { status: this.status, page: this.page })
			},
			getDetail(id){
				this.$router.push({ path: '/exchangeDetail', query: {id} })
			},
			getItem(obj){
				this.status = obj.item.id
				this.loading = false
				this.finishedtext = ''
				this.show = false,
				this.page =  1
				this.finished = false
				this.list = []
				this.initData()
			}
		}
	}
</script>
<style lang="less" scoped>
/deep/.van-list__finished-text {
	line-height: 20px !important;
	padding-bottom: 10px;
}
/deep/.van-list__loading {
	display: none;
}
</style>
